var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbsence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71415 1.64286C4.60958 1.64286 3.71415 2.53829 3.71415 3.64286C3.71415 4.74743 4.60958 5.64286 5.71415 5.64286C6.81872 5.64286 7.71415 4.74743 7.71415 3.64286C7.71415 2.53829 6.81872 1.64286 5.71415 1.64286ZM2.57129 3.64286C2.57129 1.90711 3.97839 0.5 5.71415 0.5C7.4499 0.5 8.857 1.90711 8.857 3.64286C8.857 5.37861 7.4499 6.78571 5.71415 6.78571C3.97839 6.78571 2.57129 5.37861 2.57129 3.64286Z",
    fill: "black",
    fillOpacity: 0.52
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97968 9.09912C7.28431 8.70238 6.49694 8.49522 5.69636 8.49836C4.89578 8.5015 4.11006 8.71483 3.41782 9.11701C2.72558 9.51919 2.1511 10.0961 1.75185 10.79C1.35261 11.484 1.14261 12.2706 1.14286 13.0712V14.2142H5.71429C6.02988 14.2142 6.28571 14.4701 6.28571 14.7856C6.28571 15.1012 6.02988 15.3571 5.71429 15.3571H0.571429C0.255837 15.3571 1.86546e-07 15.1012 1.86546e-07 14.7856L2.26283e-07 13.0715C2.26283e-07 13.0715 2.26283e-07 13.0716 2.26283e-07 13.0715C-0.000281346 12.0709 0.26222 11.0875 0.761244 10.2201C1.2603 9.3527 1.9784 8.63155 2.8437 8.12882C3.709 7.6261 4.69115 7.35944 5.69188 7.35551C6.6926 7.35159 7.67682 7.61054 8.54603 8.10646C8.82015 8.26286 8.91558 8.61185 8.75919 8.88597C8.60279 9.16008 8.2538 9.25551 7.97968 9.09912Z",
    fill: "black",
    fillOpacity: 0.52
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8329 10.6791C16.0561 10.9022 16.0561 11.2641 15.8329 11.4872L10.9872 16.3329C10.7641 16.5561 10.4022 16.5561 10.1791 16.3329C9.95593 16.1098 9.95593 15.748 10.1791 15.5248L15.0248 10.6791C15.248 10.4559 15.6098 10.4559 15.8329 10.6791Z",
    fill: "black",
    fillOpacity: 0.52
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1791 10.6791C10.4022 10.4559 10.7641 10.4559 10.9872 10.6791L15.8329 15.5248C16.0561 15.748 16.0561 16.1098 15.8329 16.3329C15.6098 16.5561 15.248 16.5561 15.0248 16.3329L10.1791 11.4872C9.95593 11.2641 9.95593 10.9022 10.1791 10.6791Z",
    fill: "black",
    fillOpacity: 0.52
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsence);
export default __webpack_public_path__ + "static/media/absence.42420b19d21ca496f2a9aee5c62661eb.svg";
export { ForwardRef as ReactComponent };